import { Box, Icon, Typography } from "@mui/material";
import { CustomPaper } from "../../../../../../components/CustomPaper";
import { ActionCardFooterProps, ActionCardHeaderProps, ActionCardProps, ActionCardTitleProps } from "./types";
import { useStyles } from "./styles";

export default function ActionCard({ children, icon, active, button, hover, variantCard, ...rest }: ActionCardProps) {
    const styles = useStyles({ variantCard })

    return (
        <CustomPaper {...rest} sx={{ ...styles.containerCard({ active, button, hover }), ...rest.sx }} elevation={2}>
            {icon?.position == 'start' && icon.icon}

            <Box sx={styles.container}>{children}</Box>

            {icon?.position == 'end' && icon.icon}
        </CustomPaper>
    )
}

ActionCard.Header = ({ label, children }: ActionCardHeaderProps) => (
    <Box className="flex justify-between gap-2 w-full item-center">
        <Typography variant="header_card">{label}</Typography>

        {children}
    </Box>
)

ActionCard.Title = ({ label, ...rest }: ActionCardTitleProps) => <Typography fontWeight='bold' variant={rest?.variant ?? "title"} {...rest}>{label}</Typography>

ActionCard.SubTitle = ({ label, ...rest }: ActionCardTitleProps) => <Typography fontWeight='bold' variant={rest?.variant ?? "subtitle"} {...rest}>{label}</Typography>

ActionCard.Description = ({ label, ...rest }: ActionCardTitleProps) => <Typography variant={rest?.variant ?? "subtitle"} fontWeight={500} {...rest}  className="description">{label}</Typography>

ActionCard.Footer = ({ label }: ActionCardFooterProps) => <Typography variant="footer"><i>{label}</i></Typography>
/**
 * @IMPORT: use the icon of the icons function 
 * */
ActionCard.Icon = <T extends Object>({ as: Component = Icon, icon, ...props }: { as?: any; icon: JSX.Element; } & T) => <Component<T> className="icon-action-card" color="primary" {...props}>{icon}</Component>